/**
 * File Name          : parameter.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

import { float32Bytes, float64Bytes, Int16Bytes, Int32Bytes, Int64Bytes, Int8Bytes, Uint16Bytes, Uint32Bytes, Uint64Bytes, Uint8Bytes } from "../../byte-helpers";
import { DATA_TYPE } from "../data-type.model";
import { ParameterAttribute } from "./parameter-attribute.model";

export class Parameter {
    constructor(
        public UUID: number, 
        public paramType?: DATA_TYPE, 
        public numberBytes?: number, 
        public numberElements?: number, 
        public name: string ="", 
        public attributes: ParameterAttribute[] = []
    ) {}

    parseValue(valuesBytes: Uint8Array): (number|bigint|null)[] {
        let values = [];
        let offset = 0;
        let dv = new DataView(valuesBytes!.buffer);
        
        for(let i=0; i<this.numberElements!; i++) {
            switch(this.paramType) {
                case DATA_TYPE.UINT8: {
                values.push(dv.getUint8(offset));
                offset += 1;
                break;
                }
                case DATA_TYPE.UINT16: {
                values.push(dv.getUint16(offset, true));
                offset += 2;
                break;
                }
                case DATA_TYPE.UINT32: {
                values.push(dv.getUint32(offset, true));
                offset += 4;
                break;
                }
                case DATA_TYPE.UINT64: {
                values.push(dv.getBigUint64(offset, true));
                offset += 8;
                break;
                }
                case DATA_TYPE.INT8: {
                values.push(dv.getInt8(offset));
                offset += 1;
                break;
                }
                case DATA_TYPE.INT16: {
                values.push(dv.getInt16(offset, true));
                offset += 2;
                break;
                }
                case DATA_TYPE.INT32: {
                values.push(dv.getInt32(offset, true));
                offset += 4;
                break;
                }
                case DATA_TYPE.INT64: {
                values.push(dv.getBigInt64(offset, true));
                offset += 8;
                break;
                }
                case DATA_TYPE.FLOAT32: {
                values.push(dv.getFloat32(offset, true));
                offset += 4;
                break;
                }
                case DATA_TYPE.FLOAT64: {
                values.push(dv.getFloat64(offset, true));
                offset += 8;
                break;
                }
                case DATA_TYPE.ENUM8: {
                values.push(dv.getUint8(offset));
                offset += 1;
                break;
                }
                default: {
                values.push(null);
                break;
                }
            }
        }

        return values;
    }

    bytesFromValue(value: number[]): Uint8Array {
        let bytes = new Uint8Array(this.numberBytes!);

        for(let i=0; i<this.numberElements!; i++) {
            switch(this.paramType) {
                case DATA_TYPE.UINT8: bytes.set(Uint8Bytes(value[i]), i*1); break;
                case DATA_TYPE.UINT16: bytes.set(Uint16Bytes(value[i]), i*2); break;
                case DATA_TYPE.UINT32: bytes.set(Uint32Bytes(value[i]), i*4); break;
                case DATA_TYPE.UINT64: bytes.set(Uint64Bytes(value[i]), i*8); break;
                case DATA_TYPE.INT8: bytes.set(Int8Bytes(value[i]), i*1); break;
                case DATA_TYPE.INT16: bytes.set(Int16Bytes(value[i]), i*2); break;
                case DATA_TYPE.INT32: bytes.set(Int32Bytes(value[i]), i*4); break;
                case DATA_TYPE.INT64: bytes.set(Int64Bytes(value[i]), i*8); break;
                case DATA_TYPE.FLOAT32: bytes.set(float32Bytes(value[i]), i*4); break;
                case DATA_TYPE.FLOAT64: bytes.set(float64Bytes(value[i]), i*8); break;
                case DATA_TYPE.ENUM8: bytes.set(Uint8Bytes(value[i]), i*1); break;
                default: break;
            }
        }
        return bytes;
    }

}